/**
 * Plan & Subscription Constants
 *
 * Copied from scio2: optisigns-portal-common/libs/common/constant/src/lib/subscription.constant.ts
 */

// --- Payment Status Codes ---

export const PAYMENT_STATUS_CODE = {
  ZIPCODE_ISSUE: 1010,
  PAYMENT_FAILED: 1001,
  LIMIT_QUANTITY: 5555,
  ROLLBACK: 5556,
  UNPAID_INVOICE: 5557,
  /**
   * A payment is already running on this account — a second tab, a double submit, or a refresh
   * that landed mid-charge. NOT a failure: the server refused to charge again rather than risk
   * billing twice, and the first payment is still going through. Callers must not treat this as
   * an error state or send the customer away.
   */
  PAYMENT_IN_PROGRESS: 6005,
} as const;

export type PaymentStatusCode = (typeof PAYMENT_STATUS_CODE)[keyof typeof PAYMENT_STATUS_CODE];

// --- Plan Constants ---

export const FREE_PLAN = 'free';
export const MIN_PAY_PLAN = 'standard';

export const PLAN_FEATURES = {
  FREE_PLAN: FREE_PLAN,
  STANDARD: 'standard',
  PRO: 'pro',
  PRO_PLUS: 'proPlus',
  ENGAGE: 'engage',
  ENTERPRISE: 'enterprise',
} as const;

export type PlanFeatureType = (typeof PLAN_FEATURES)[keyof typeof PLAN_FEATURES];

export const PLAN_TEXT_FEATURES: Record<string, string> = {
  free: 'Free',
  standard: 'Standard',
  // Legacy `pro` accounts display their real plan name "Pro" (matching the
  // catalog `productPlans` doc name and the Subscription page), so a pro
  // customer is never mislabeled as "Pro Plus" — which alarmed legacy
  // customers into thinking a quantity change upgraded their tier.
  // `proPlus` is the separate, newer canonical tier.
  pro: 'Pro',
  proPlus: 'Pro Plus',
  engage: 'Engage',
  enterprise: 'Enterprise',
};

// --- Billing Interval ---

export const BILLING_INTERVAL = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  YEARLY_FREEDEVICE: 'yearly_freedevice',
} as const;

export type BillingInterval = (typeof BILLING_INTERVAL)[keyof typeof BILLING_INTERVAL];

// --- Free Plan Limits ---

export const FREE_PLAN_LIMITS = {
  MAX_SPLIT_SCREEN_ZONE: 3,
  MAX_ITEMS_PLAYLIST: 30,
  MAX_FILE_SIZE_PLAYLIST: 209715200, // ~200 MB
  MAX_OPTISIGNS_DEVICES: 2,
  MAX_NOT_SUPPORT: 0,
  MAX_USER: 3,
  MAX_DEVICE_OPTISIGNS: 25,
  MAX_STORAGE: 1073741824, // 1 GB
  MAX_SIZE_UPLOAD: 26214400, // 25 MB
} as const;

// --- Add-On Types ---

export const COMMON_TYPE_SUBSCRIPTION_ADD_ONS = [
  'aericast',
  'videowall',
  'backgroundmusic',
  'optidev',
] as const;

export type SubscriptionAddOn = (typeof COMMON_TYPE_SUBSCRIPTION_ADD_ONS)[number];
